import { find } from 'lodash/fp';

import BreakpointRange from './BreakpointRange';
import { BreakpointRangeValue } from './types';

export const atMost =
    (upperBound: BreakpointRangeValue) =>
    (range: BreakpointRangeValue): boolean =>
        range.high <= upperBound.high;

export const atLeast =
    (lowerBound: BreakpointRangeValue) =>
    (range: BreakpointRangeValue): boolean =>
        lowerBound.low <= range.low;

export const getBreakpointRange = (): BreakpointRangeValue =>
    find((b) => window.matchMedia(`(min-width: ${b.low}px) and (max-width: ${b.high}px)`).matches, BreakpointRange) ||
    BreakpointRange.Phone;

export const isAtMostMobile = atMost(BreakpointRange.Phone);
export const isAtLeastTabletPortrait = atLeast(BreakpointRange.TabletPortrait);
export const isAtLeastTabletLandscape = atLeast(BreakpointRange.TabletLandscape);
export const isAtLeastDesktop = atLeast(BreakpointRange.Desktop);

export const mediaMinWidth = (breakpointRange: BreakpointRangeValue) => `@media (min-width: ${breakpointRange.low}px)`;
export const mediaMaxWidth = (breakpointRange: BreakpointRangeValue) => `@media (max-width: ${breakpointRange.high}px)`;
